<template>
    <stages-template
        :data="data"
        @onClickStage="onClickStage"
        :selected.sync="selected"
        :disabled="!canChangeUserStage"
    />
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import { updateUserStage } from './api'
import { Template } from './components'

export default {
    name: 'ChangeUserStage',
    props: {
        data: {
            type: Object,
            required: true,
        },
        currentUser: {
            type: Object,
            required: true,
        },
        userID: {
            type: Number,
            required: true,
        },
    },
    components: {
        StagesTemplate: Template,
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        onClickStage(stageId) {
            if (stageId != this.data.current.id) {
                this.selected = stageId
                const selectedStage = this.data.all.find((stage) => stage.id == stageId).title
                const currentStage = this.data.current.title
                Swal(this.createConfigToSwal(currentStage, selectedStage)).then((response) => {
                    if (response.value) {
                        updateUserStage(this.userID, stageId).then(() => {
                            this.$emit('updated')
                        })
                    } else if (response.dismiss) {
                        return (this.selected = this.data.current.id)
                    }
                })
            }
        },
        createConfigToSwal(currentStage, selectedStage) {
            return {
                text: i18n.t('stages.confirmChangeOfStage', {
                    currentStage,
                    selectedStage,
                }),
                type: 'warning',
                title: i18n.t('notification.areYouSure'),
                confirmButtonText: i18n.t('notification.yes'),
                cancelButtonText: i18n.t('notification.no'),
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                showCancelButton: true,
            }
        },
    },
    computed: {
        canChangeUserStage() {
            return (
                this.currentUser.role.name === 'administrator' ||
                this.currentUser.role.name === 'local_administrator' ||
                this.currentUser.role.name === 'god' ||
                this.currentUser.is_target_master ||
                (this.currentUser.is_manager && this.currentUser.id != this.userID)
            )
        },
    },
}
</script>
